import { useEffect, useState } from "react";

import { BottomSheet } from "../BottomSheet";
import { Button as ButtonV2 } from "../Button";
import { RadioGroupV2 } from "../RadioGroup/RadioGroupV2";
import type { MarketingBannersTranslations } from "./types";

export type BannerSortOrder = "newest" | "oldest";

type BannerBottomSheetSortByProps = {
  isOpen: boolean;
  onClose: () => void;
  translations: MarketingBannersTranslations;
  currentSortOrder: BannerSortOrder;
  onApply: (sortOrder: BannerSortOrder) => void;
};

export const BannerBottomSheetSortBy = ({
  isOpen,
  onClose,
  translations,
  currentSortOrder,
  onApply,
}: BannerBottomSheetSortByProps) => {
  const [sortOrder, setSortOrder] = useState<BannerSortOrder>(currentSortOrder);

  useEffect(() => {
    if (isOpen) setSortOrder(currentSortOrder);
  }, [isOpen, currentSortOrder]);

  const options = [
    {
      label: translations.sortSheet.createdNewestFirst,
      value: "newest",
    },
    {
      label: translations.sortSheet.createdOldestFirst,
      value: "oldest",
    },
  ];

  const handleApply = () => {
    onApply(sortOrder);
    onClose();
  };

  return (
    <BottomSheet
      isOpen={isOpen}
      onClose={onClose}
      title={translations.sortSheet.title}
      contentContainerClassName="p-[unset]"
    >
      <div className="flex w-full flex-col items-stretch justify-start">
        <div className="flex flex-col gap-3 p-4">
          <RadioGroupV2
            value={sortOrder}
            options={options}
            onChange={(value) => setSortOrder(value as BannerSortOrder)}
          />
        </div>
        <div className="flex flex-col px-4 pb-4 pt-3">
          <ButtonV2 variant="brand" onClick={handleApply} className="w-full">
            {translations.sortSheet.apply}
          </ButtonV2>
        </div>
      </div>
    </BottomSheet>
  );
};
